<div class="step-two-col">
  <div class="step-col-main">
    <followup-template></followup-template>
    <meeting-completed></meeting-completed>
  </div>
  <div class="step-col-report">
    <report></report>
  </div>
</div>